/* ============================================================
   VD Results Buy Box (Tabs) — behaviour
   sections/vd-real-results-buybox-tabs.liquid

   - Gallery: scroll-snap track; the thumbnail buttons pick the image on desktop
     and are the dots on smartphone (swipe the track to move).
   - Tabs (Capsules / Gummies): toggles `hidden` on the panels, ARIA tabs keyboard
     support, and moves the single FrontRow sticker iframe to the active panel.
   - Plans: the radio changes the card state and the hidden cart form (variant,
     selling plan, quantity, button label).
   - Cart: same flow as the Kris Jenner landing page. When a gift is owed
     (window.GiftBundle, sections/gift-rules.liquid) it is bundled into the same
     /cart/add.js call; either way the shopper ends up at /checkout.
   Vanilla JS, idempotent, theme-editor aware.
   ============================================================ */
(function () {
  'use strict';

  if (window.__vdRrBuyboxTabsLoaded) return;
  window.__vdRrBuyboxTabsLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STICKER_BASE = 'https://app.thefrontrowhealth.com/api/widgets';

  function initGallery(gallery) {
    if (gallery.dataset.vdrbInit === '1') return;
    gallery.dataset.vdrbInit = '1';

    var track = gallery.querySelector('[data-vdrb-track]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-vdrb-thumb]'));
    if (!track) return;
    var slides = track.children;

    function mark(i) {
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        if (!slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        mark(i);
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        mark(Math.round(track.scrollLeft / (track.clientWidth || 1)));
      });
    }, { passive: true });
  }

  function showError(panel, message) {
    var el = panel.querySelector('[data-vdrb-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function initPanel(panel) {
    if (panel.dataset.vdrbPanelInit === '1') return;
    panel.dataset.vdrbPanelInit = '1';

    var gallery = panel.querySelector('[data-vdrb-gallery]');
    if (gallery) initGallery(gallery);

    var plans = panel.querySelectorAll('[data-vdrb-plan]');
    var radios = panel.querySelectorAll('[data-vdrb-radio]');
    var form = panel.querySelector('[data-vdrb-form]');
    var variantInput = panel.querySelector('[data-vdrb-variant]');
    var sellingPlanInput = panel.querySelector('[data-vdrb-selling-plan]');
    var quantityInput = panel.querySelector('[data-vdrb-quantity]');
    var cta = panel.querySelector('[data-vdrb-cta]');
    var ctaText = panel.querySelector('[data-vdrb-cta-text]');

    function syncCta(radio) {
      if (!variantInput) return;
      var variantId = radio.getAttribute('data-variant-id') || '';
      var label = radio.getAttribute('data-cta-label') || '';
      if (ctaText && label) ctaText.textContent = label;
      variantInput.value = variantId;
      if (sellingPlanInput) sellingPlanInput.value = radio.getAttribute('data-selling-plan-id') || '';
      if (quantityInput) quantityInput.value = radio.getAttribute('data-quantity') || '1';
      if (cta) {
        if (variantId) {
          cta.removeAttribute('disabled');
          cta.removeAttribute('aria-disabled');
        } else {
          cta.setAttribute('disabled', '');
          cta.setAttribute('aria-disabled', 'true');
        }
      }
      showError(panel, '');
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        plans.forEach(function (p) { p.classList.remove('is-selected'); });
        var card = radio.closest('[data-vdrb-plan]');
        if (card) card.classList.add('is-selected');
        syncCta(radio);
      });
    });

    if (!form) return;

    function setLoading(on) {
      if (!cta) return;
      cta.classList.toggle('is-loading', on);
      if (on) cta.setAttribute('aria-busy', 'true');
      else cta.removeAttribute('aria-busy');
      cta.disabled = on;
    }

    function addToCart(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      });
    }

    form.addEventListener('submit', function (e) {
      if (variantInput && !variantInput.value) {
        e.preventDefault();
        return;
      }

      showError(panel, '');
      var sellingPlanId = sellingPlanInput ? sellingPlanInput.value : '';
      var giftInfo = (window.GiftBundle && typeof window.GiftBundle.info === 'function')
        ? window.GiftBundle.info(variantInput ? variantInput.value : '', sellingPlanId)
        : null;

      if (giftInfo) {
        e.preventDefault();
        setLoading(true);

        var mainItem = {
          id: parseInt(variantInput.value, 10),
          quantity: parseInt(quantityInput ? quantityInput.value : '1', 10) || 1
        };
        if (sellingPlanId) mainItem.selling_plan = parseInt(sellingPlanId, 10);

        // Bundle the gift into the same add; on failure fall back to the main item only.
        window.GiftBundle.augment([mainItem])
          .then(function (items) { return addToCart(items); })
          .then(function (result) {
            if (result.ok) {
              window.location.href = '/checkout';
              return;
            }
            console.warn('[vd-buybox] add with gift failed, retrying main only', result.status, result.data);
            return addToCart([mainItem]).then(function (retry) {
              if (retry.ok) {
                window.location.href = '/checkout';
              } else {
                console.error('[vd-buybox] add main only also failed', retry.status, retry.data);
                showError(panel, (retry.data && retry.data.description) || 'Could not add to cart. Please try again.');
                setLoading(false);
              }
            });
          })
          .catch(function (err) {
            console.error('[vd-buybox] network error', err);
            showError(panel, 'Network error. Please try again.');
            setLoading(false);
          });
        return;
      }

      // No gift owed: let the native form post run (return_to=/checkout). A blank
      // selling plan must not be sent, or Shopify rejects the one-time add.
      if (sellingPlanInput && !sellingPlanInput.value) sellingPlanInput.disabled = true;
      setLoading(true);
    });

    // Back/bfcache restore keeps the loading state; clear it.
    window.addEventListener('pageshow', function () {
      setLoading(false);
      if (sellingPlanInput) sellingPlanInput.disabled = false;
    });
  }

  function initSection(root) {
    if (root.dataset.vdrbInit === '1') return;
    root.dataset.vdrbInit = '1';

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-vdrb-panel]'));
    var tabButtons = root.querySelectorAll('[data-vdrb-tab]');
    panels.forEach(initPanel);

    /* FrontRow sticker: one #frontrow-sticker iframe (the FrontRow script binds to that exact
       id). Move it into the active panel's gallery and point it at that tab's product. */
    var loadedStickerScripts = {};
    (function () {
      var initial = root.querySelector('#frontrow-sticker');
      var m = initial && (initial.getAttribute('src') || '').match(/product_id=(\d+)/);
      if (m) loadedStickerScripts[m[1]] = true;
    })();

    function loadStickerScript(id) {
      if (!id || loadedStickerScripts[id]) return;
      loadedStickerScripts[id] = true;
      var s = document.createElement('script');
      s.async = true;
      s.src = STICKER_BASE + '/script?presentation_type=sticker&product_id=' + id;
      root.appendChild(s);
    }

    function updateSticker(tab) {
      var sticker = root.querySelector('#frontrow-sticker');
      var panel = root.querySelector('[data-vdrb-panel="' + tab + '"]');
      var gallery = panel && panel.querySelector('[data-vdrb-gallery]');
      var id = gallery && gallery.getAttribute('data-frontrow-id');
      if (!sticker || !gallery || !id) return;
      if (sticker.parentNode !== gallery) gallery.appendChild(sticker);
      var src = STICKER_BASE + '?presentation_type=sticker&product_id=' + id;
      if (sticker.getAttribute('src') !== src) {
        sticker.setAttribute('src', src);
        loadStickerScript(id);
      }
    }

    function activate(tab, moveFocus) {
      tabButtons.forEach(function (b) {
        var on = b.getAttribute('data-vdrb-tab') === tab;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-vdrb-panel') !== tab;
      });
      updateSticker(tab);
      if (moveFocus) {
        // The tablist that was focused is now hidden; focus its twin in the visible panel.
        var visible = root.querySelector('[data-vdrb-panel]:not([hidden]) [data-vdrb-tab="' + tab + '"]');
        if (visible) visible.focus();
      }
    }

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-vdrb-tab'), false);
      });

      // ARIA tabs pattern: arrows, Home, End.
      btn.addEventListener('keydown', function (e) {
        var list = btn.closest('[role="tablist"]');
        if (!list) return;
        var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
        var i = tabs.indexOf(btn);
        var next;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        else return;
        e.preventDefault();
        activate(tabs[next].getAttribute('data-vdrb-tab'), true);
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vdrb]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
